import { render } from "./ColumChart.vue?vue&type=template&id=c4f3b712"
import script from "./ColumChart.vue?vue&type=script&lang=js"
export * from "./ColumChart.vue?vue&type=script&lang=js"

import exportComponent from "D:\\root\\baam\\viribuz\\viribuz-dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__